import { render, staticRenderFns } from "./ModifyPressNewForm.vue?vue&type=template&id=86f8587a"
import script from "./ModifyPressNewForm.vue?vue&type=script&lang=js"
export * from "./ModifyPressNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports